import { styled } from '@mui/material';
import React from 'react'

const QuestionHeading = (props:{children:React.ReactNode, disableTextTransform?: boolean}) => {
  const {children}=props;
  const Wrapper= styled('div')(`
    border-left:var(--dashboard-secondary-color) solid 3px;
    font-size:1.00rem;
    text-align:left;
    padding-left:0.5rem;
    font-weight:600;
    text-transform: ${props.disableTextTransform? "none" : "lowercase"};
    &::first-letter {
    text-transform:${props.disableTextTransform? "none" : "capitalize"};
    }
  `)
  return (
    <Wrapper>
        {children}
    </Wrapper>
  )
}

export default QuestionHeading